require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.join");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/dialog/style", "vant/es/dialog", "vant/es/toast/style", "vant/es/toast", "vant/es/loading/style", "vant/es/loading"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/dialog/style"), require("vant/es/dialog"), require("vant/es/toast/style"), require("vant/es/toast"), require("vant/es/loading/style"), require("vant/es/loading"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.dialog, global.style, global.toast, global.style, global.loading);
    global.qaEngine = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _dialog, _style2, _toast, _style3, _loading) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _dialog = _interopRequireDefault(_dialog);
  _toast = _interopRequireDefault(_toast);
  _loading = _interopRequireDefault(_loading);
  var _default = {
    name: 'XiazengQaEngine',
    components: {
      Loading: _loading.default
    },
    data: function data() {
      var ossHostPond = this.$config.base.ossHostPond;
      return {
        ossPondHost: ossHostPond,
        // 设备信息
        info: {},
        // 设备在列表中的索引
        deviceIndex: -1,
        // 模式: check=质检 view=查看
        mode: 'check',
        // 扫码获取的设备编号
        uniqueId: '',
        // 步骤状态 0=未开始 1=成功 2=失败 3=进行中
        step1Status: 0,
        step2Status: 0,
        step3Status: 0,
        step5Status: 0,
        // 前四项是否全部完成（除重启步骤外）
        firstFourDone: false,
        // 步骤4（信号强度）
        step4Status: 0,
        // 步骤4当前信号值
        signalValue: null,
        // 步骤4信号合格要求值（需≥此值）
        signalRequired: 25,
        // 步骤2失败原因
        step2FailReason: '',
        // 是否可以提交（五步全部成功）
        canSubmit: false,
        // 轮询定时器
        pollTimer: null,
        // 设备打样过程状态（含视频/照片地址）
        processState: {},
        // 打样视频照片弹框
        showMediaModal: false,
        showPreviewImg: false,
        currentIndex: 0,
        picUrl: '',
        videoUrl: ''
      };
    },
    computed: {
      // 当前信号值展示，无值时为 -
      displaySignal: function displaySignal() {
        var value = this.signalValue;
        return value === null || value === undefined || value === '' ? '-' : value;
      }
    },
    created: function created() {
      var vm = this;
      var _vm$$route$query = vm.$route.query,
          index = _vm$$route$query.index,
          mode = _vm$$route$query.mode;
      var deviceIndex = Number(index);
      vm.deviceIndex = deviceIndex;
      vm.mode = mode || 'check'; // 从路由 state 获取设备列表信息（由 checkList 页传入）

      var listStr = sessionStorage.getItem('xiazengCheckList') || '[]';
      var preList = [];

      try {
        preList = JSON.parse(listStr);
      } catch (e) {
        preList = [];
      }

      var info = preList[deviceIndex] || {};
      info.displayImei = info.imei || '-';
      info.displayIccid = info.iccid || '-';
      vm.info = info; // 查看模式: 所有步骤显示已完成

      if (mode === 'view') {
        vm.step1Status = 1;
        vm.step2Status = 1;
        vm.step3Status = 1;
        vm.step4Status = 1;
        vm.step5Status = 1;
        vm.firstFourDone = true;
        vm.canSubmit = false; // 查看模式: 拉取一次设备详情获取打样媒体数据

        vm.fetchProcessMedia();
        return;
      } // 质检模式: 立即查询设备当前状态并开始轮询


      vm.pollDeviceStatus();
      vm.startPoll(); // 初始化微信 JSSDK

      vm.weixinInit(); // 检查从手动输入页返回的编号

      var manualUniqueId = sessionStorage.getItem('xiazengManualUniqueId');

      if (manualUniqueId) {
        sessionStorage.removeItem('xiazengManualUniqueId');
        vm.uniqueId = manualUniqueId;
        vm.doStep1();
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.stopPoll();
    },
    methods: {
      // ==================== 微信 JSSDK ====================
      weixinInit: function weixinInit() {
        var vm = this;
        vm.$http({
          method: 'GET',
          url: "https://m.yudada.com/jssdk/configuration?url=".concat(location.href)
        }).then(function (res) {
          var _res$data = res.data,
              appId = _res$data.appId,
              nonceStr = _res$data.nonceStr,
              signature = _res$data.signature,
              timestamp = _res$data.timestamp;
          window.wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: ['scanQRCode']
          });
        });
      },
      // ==================== 轮询设备状态 ====================
      startPoll: function startPoll() {
        var vm = this;
        vm.stopPoll();
        vm.pollTimer = setInterval(function () {
          vm.pollDeviceStatus();
        }, 5000);
      },
      stopPoll: function stopPoll() {
        if (this.pollTimer) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
        }
      },
      // 查询单台设备详情，更新各步骤状态
      pollDeviceStatus: function pollDeviceStatus() {
        var vm = this;
        var info = vm.info;
        if (!info.iccid) return;
        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/device/".concat(info.iccid)
        }).then(function (res) {
          vm.updateStepStatus(res.data);
        }).catch(function () {});
      },
      // 根据设备详情更新步骤状态
      updateStepStatus: function updateStepStatus(device) {
        var vm = this;
        var ps = device && device.processState || {};
        vm.processState = ps; // 步骤1: configState SENT/ACKED=进行中 SUCCESS=成功 FAILED/TIMEOUT=失败

        var configState = ps.configState || '';

        if (configState === 'SUCCESS') {
          vm.step1Status = 1;
          vm.uniqueId = ps.serverUniqueId || vm.uniqueId;
        } else if (configState === 'FAILED' || configState === 'TIMEOUT') {
          vm.step1Status = 2;
        } else if (configState === 'SENT' || configState === 'ACKED') {
          vm.step1Status = 3;
        } // 步骤2: sampleState CMD_SENT/CMD_ACKED/SAMPLING=检测中 COMPLETED=成功 FAILED/TIMEOUT=失败


        var sampleState = ps.sampleState || 'IDLE';

        if (sampleState === 'COMPLETED') {
          vm.step2Status = 1;
          vm.step2FailReason = '';
        } else if (sampleState === 'FAILED' || sampleState === 'TIMEOUT') {
          vm.step2Status = 2;
          vm.step2FailReason = vm.getStep2FailReason(ps, sampleState);
        } else if (sampleState === 'CMD_SENT' || sampleState === 'CMD_ACKED' || sampleState === 'SAMPLING') {
          vm.step2Status = 3;
          vm.step2FailReason = '';
        } // 步骤3: buttonChecked true=已完成


        vm.step3Status = ps.buttonChecked ? 1 : 0; // 步骤4（信号强度）: signalQualified true=通过 false=不通过

        vm.signalValue = ps.signal != null ? ps.signal : device.signal;

        if (device.signalQualified) {
          vm.step4Status = 1;
        } else {
          vm.step4Status = 2;
        } // 步骤5: formalRegisterState IDLE=空闲 WAITING=等待注册 SUCCESS=注册成功 TIMEOUT=超时失败


        var formalRegisterState = ps.formalRegisterState || 'IDLE';

        if (formalRegisterState === 'SUCCESS') {
          vm.step5Status = 1;
        } else if (formalRegisterState === 'TIMEOUT') {
          vm.step5Status = 2;
        } else if (formalRegisterState === 'WAITING') {
          vm.step5Status = 3;
        } else {
          vm.step5Status = 0;
        }

        vm.$nextTick(function () {
          vm.checkCanSubmit();
        });
      },
      // 解析步骤2失败原因
      getStep2FailReason: function getStep2FailReason(ps, sampleState) {
        var reasons = [];
        if (sampleState === 'TIMEOUT') reasons.push('检测超时');
        if (ps.deviceReportCompleted === false) reasons.push('打样上报失败');
        if (ps.forceRelaxed === false || ps.forceTightened === false || ps.topSwitchTriggered === false) reasons.push('未到达限位');
        if (ps.imageUploaded === false) reasons.push('图片上传失败');
        if (ps.videoUploaded === false) reasons.push('视频上传失败');
        return reasons.join('、');
      },
      // ==================== 打样媒体查看 ====================
      // videoUrl/imageUrl 兼容字符串或数组格式，取第一个有效值
      getUrl: function getUrl(val) {
        if (!val) return '';

        if (Array.isArray(val)) {
          return val.find(function (item) {
            return !!item;
          }) || '';
        }

        return val;
      },
      // 查看模式: 拉取一次设备详情获取打样媒体数据
      fetchProcessMedia: function fetchProcessMedia() {
        var vm = this;
        var info = vm.info;
        if (!info.iccid) return;
        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/device/".concat(info.iccid)
        }).then(function (res) {
          var device = res.data;

          if (device && device.processState) {
            vm.processState = device.processState;
          }
        }).catch(function () {});
      },
      openMediaModal: function openMediaModal() {
        var vm = this;
        var ps = vm.processState || {};
        vm.picUrl = vm.getUrl(ps.imageUrl);
        vm.videoUrl = vm.getUrl(ps.videoUrl);
        vm.showMediaModal = true;
        vm.showPreviewImg = false;
        vm.currentIndex = 0;
      },
      closeMediaModal: function closeMediaModal() {
        this.showMediaModal = false;
        this.showPreviewImg = false;
        var video = this.$refs.mediaVideo;

        if (video) {
          video.pause();
        }
      },
      changeMediaIndex: function changeMediaIndex(index) {
        this.currentIndex = index;
      },
      // ==================== 步骤操作 ====================
      // 公共方法: 调用 workflow 接口下发指令
      doWorkflow: function doWorkflow(query, loadingText) {
        var vm = this;
        var info = vm.info;

        if (loadingText) {
          _toast.default.loading({
            message: loadingText,
            forbidClick: true,
            duration: 2000
          });
        }

        vm.$http({
          method: 'POST',
          url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/device/workflow/".concat(info.iccid, "?").concat(query)
        }).then(function () {
          setTimeout(function () {
            vm.pollDeviceStatus();
          }, 1000);
        }).catch(function () {});
      },
      // 步骤1: 扫码录入设备编号
      onclickScanBtn: function onclickScanBtn() {
        var vm = this;
        if (vm.mode === 'view') return;
        vm.uniqueId = ''; // 使用微信 JSSDK 扫码

        if (window.wx && window.wx.scanQRCode) {
          window.wx.scanQRCode({
            needResult: 1,
            scanType: ['qrCode'],
            success: function success(res) {
              var result = res.resultStr;

              if (result.indexOf('deviceId=') < 0) {
                (0, _toast.default)('请扫描正确的二维码');
                return;
              }

              var encodeId = result.split('deviceId=')[1];

              if (!encodeId) {
                (0, _toast.default)('请扫描正确的二维码');
                return;
              }

              var loading = _toast.default.loading({
                message: '识别中',
                forbidClick: true,
                duration: 0
              });

              vm.$http({
                method: 'GET',
                url: vm.$config.base.PROBE_BASE_URL + "device/info?encodeId=".concat(encodeId)
              }).then(function (rs) {
                loading.clear();

                if (!rs.data.uniqueId) {
                  (0, _toast.default)('未获取到设备编号');
                  return;
                }

                vm.uniqueId = rs.data.uniqueId;
                vm.doStep1();
              }).catch(function () {
                loading.clear();
              });
            }
          });
        }
      },
      // 点击手动输入按钮，跳转手动输入编号页
      onclickManualBtn: function onclickManualBtn() {
        var vm = this;
        if (vm.mode === 'view') return;
        vm.$router.push({
          path: './manualInput'
        });
      },
      // 步骤1: 下发配置 (step=1)
      doStep1: function doStep1() {
        var vm = this;
        var uniqueId = vm.uniqueId;
        vm.step1Status = 3;
        vm.doWorkflow("step=1&uniqueId=".concat(uniqueId, "&hwVersion=0"), '下发配置中');
      },
      // 步骤2: 远程打样测试 (step=2)
      onclickRemoteTestBtn: function onclickRemoteTestBtn() {
        var vm = this;
        if (vm.mode === 'view') return;
        if (vm.step2Status === 3) return;
        vm.step2Status = 3;
        vm.doWorkflow('step=2', '远程打样检测中');
      },
      // 步骤5: 重启并切换到线上环境 (step=3)
      onclickRestartBtn: function onclickRestartBtn() {
        var vm = this;
        if (vm.mode === 'view') return;
        if (vm.step5Status === 3) return;
        vm.step5Status = 3;
        var uniqueId = vm.uniqueId;
        var USER_NAME = vm.$config.keys.USER_NAME;
        var operationName = vm.$localStorage.getItem(USER_NAME) || '';
        vm.doWorkflow("step=3&uniqueId=".concat(uniqueId, "&operationName=").concat(operationName), '下发重启指令中');
      },
      // 点击亮灯
      onclickLightBtn: function onclickLightBtn() {
        var vm = this;

        if (!vm.info.iccid) {
          (0, _toast.default)('设备ICCID为空');
          return;
        }

        var toast = _toast.default.loading({
          message: '亮灯中...',
          forbidClick: true,
          duration: 0
        });

        vm.$http({
          method: 'POST',
          url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/device/".concat(vm.info.iccid, "/light/blink?duration=5")
        }).then(function () {
          toast.clear();
          (0, _toast.default)('设备指示灯已闪烁');
        }).catch(function () {
          toast.clear();
        });
      },
      // ==================== 提交 ====================
      // 判断是否可以提交（五步全部成功）
      checkCanSubmit: function checkCanSubmit() {
        var vm = this;
        var firstFourDone = vm.step1Status === 1 && vm.step2Status === 1 && vm.step3Status === 1 && vm.step4Status === 1;
        var canSubmit = firstFourDone && vm.step5Status === 1;
        vm.firstFourDone = firstFourDone;
        vm.canSubmit = canSubmit;
      },
      // 确认正式服务登录
      onclickSubmitBtn: function onclickSubmitBtn() {
        var vm = this;
        if (!vm.canSubmit) return;
        var uniqueId = vm.uniqueId;

        _dialog.default.confirm({
          title: '质检提示',
          message: "\u8BBE\u5907".concat(uniqueId, "\u5DF2\u901A\u8FC7\u5168\u90E8\u8D28\u68C0\u9879\uFF0C\u662F\u5426\u63D0\u4EA4\u8D28\u68C0\u7ED3\u679C\uFF1F"),
          confirmButtonText: '提 交',
          cancelButtonText: '取 消'
        }).then(function () {
          vm.confirmSubmit();
        }).catch(function () {});
      },
      // 确认提交 - 调用 confirmServerLogin 确认正式服务登录
      confirmSubmit: function confirmSubmit() {
        var vm = this;
        var uniqueId = vm.uniqueId;

        var toast = _toast.default.loading({
          message: '提交中',
          forbidClick: true,
          duration: 0
        });

        vm.$http({
          method: 'POST',
          url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/confirmServerLogin?uniqueId=".concat(uniqueId)
        }).then(function () {
          toast.clear();
          (0, _toast.default)('质检提交成功');
          setTimeout(function () {
            vm.$router.back();
          }, 1500);
        }).catch(function () {
          toast.clear();
        });
      }
    }
  };
  _exports.default = _default;
});